import { InMemoryCache } from 'apollo-cache-inmemory'

const __typename = 'SignaturePoints'

const defaults = {
  signaturePoints: {
    __typename,
    id: null,
    points: null,
    width: null,
  },
}

type SignatureParams = {
  points: number[]
  width: number
}

const resolvers = {
  Mutation: {
    updateSignaturePoints: (
      _: any,
      { points, width }: SignatureParams,
      { cache }: { cache: InMemoryCache },
    ) => {
      const data = {
        signaturePoints: {
          __typename,
          id: null,
          points,
          width,
        },
      }
      cache.writeData({ data })
      return null
    },
  },
}

export { defaults, resolvers }
